import { adminInvitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiInvitationHandler } from "@/services/shared";
import type {
    ApiInvitationType,
    CreateInvitationRequestType,
    CreateInvitationResponseType,
} from "@/types";

interface ApiCreateInvitationResponseInterface {
    invitation: ApiInvitationType,
    message: string,
    registration_url?: string | null, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case response
    token?: string | null,
}

export const createInvitationHandler = async ({ email }: CreateInvitationRequestType): Promise<CreateInvitationResponseType> => {
    const response = await axiosClient.post<ApiCreateInvitationResponseInterface>(
        adminInvitationsEndpoints.base,
        { email },
    );

    const invitation = transformApiInvitationHandler(response.data.invitation);

    const registrationUrl = response.data.registration_url ?? invitation.registrationUrl ?? null;

    return {
        invitation: {
            ...invitation,
            registrationUrl,
        },
        message: response.data.message,
        registrationUrl,
        token: response.data.token ?? null,
    };
};
